import React from "react";
import { UserThemeContextContent } from "../Helpers/userTheme";
import { cacheService } from "../../Core/Api/services";
import { AppTheme } from "../../Core/Api/Types/db-user-infos";

const useUserTheme = (): {
  userTheme: UserThemeContextContent["userTheme"];
  setUserTheme: UserThemeContextContent["setUserTheme"];
} => {
  const [userTheme, setUserTheme] = React.useState<UserThemeContextContent["userTheme"]>("dark"); // dark default

  React.useEffect(() => {
    setUserTheme(() => {
      const currTheme = localStorage.getItem("userTheme");
      if (currTheme !== userTheme) {
        localStorage.setItem("userTheme", userTheme);
        console.log("setUserTheme(ls)::", userTheme);
      }
      return userTheme;
    });
  }, [userTheme]);

  React.useEffect(() => {
    setUserTheme(() => {
      let userThemePrefs = cacheService.GetUserInfo()?.prefs?.theme;
      let userTheme = userThemePrefs ? (userThemePrefs === AppTheme.Dark ? "dark" : "light") : "dark";

      const currTheme = localStorage.getItem("userTheme");
      if (currTheme !== userTheme) {
        localStorage.setItem("userTheme", userTheme);
        console.log("setUserTheme(prefs)::", userTheme);
      }
      return userTheme;
    });
  }, [cacheService.GetUserInfo()?.prefs?.theme]);

  return {
    userTheme,
    setUserTheme,
  };
};

export default useUserTheme;
